import { defineOutcome, type CatalogOutcomeDefinitionMap } from './catalogCapabilities.types';

export const discoveryCatalogOutcomeDefinitions: CatalogOutcomeDefinitionMap = {
  ahrefs: [
    defineOutcome('Research keywords and opportunities', 'Keyword ideas, difficulty, volume buckets, and ranking needs', 'ahrefs.keyword_ideas', 'ahrefs.keywords'),
    defineOutcome('Analyze domains and backlinks', 'Domain Rating, referring domains, pages, and anchor text', 'ahrefs.overview', 'ahrefs.backlinks'),
  ],
  coinmarketcap: [
    defineOutcome('Track cryptocurrency markets', 'Rank, price, market cap, volume, and daily change', 'coinmarketcap.listings'),
  ],
  congress: [
    defineOutcome('Track congressional stock trades', 'Members, tickers, transaction types, amounts, and dates', 'congress.trades'),
  ],
  google: [
    defineOutcome('Research the open web', 'Web results, news, scholarly papers, patents, and videos', 'google.search', 'google.news', 'google.scholar', 'google.patents', 'google.videos'),
    defineOutcome('Discover images and visual matches', 'Image search, source pages, dimensions, and reverse matches', 'google.images', 'google.lens'),
    defineOutcome('Find search demand signals', 'Autocomplete suggestions and keyword ideas', 'google.autocomplete'),
  ],
  google_ads: [
    defineOutcome('Research advertisers and campaigns', 'Advertisers, active ads, creative formats, and run dates', 'google_ads.search', 'google_ads.company_ads', 'google_ads.advertiser_search'),
    defineOutcome('Inspect individual ad creatives', 'Creative variations, regions, impressions, and schedules', 'google_ads.ad_details'),
  ],
  google_finance: [
    defineOutcome('Track financial market quotes', 'Prices, daily changes, volume, market cap, and trading ranges', 'google_finance.quote'),
  ],
  polymarket: [
    defineOutcome('Track prediction markets', 'Markets, probabilities, volume, liquidity, and outcomes', 'polymarket.markets'),
  ],
  sec: [
    defineOutcome('Research SEC filings', 'Forms, companies, filing dates, accession numbers, and documents', 'sec.filings'),
  ],
  semrush: [
    defineOutcome('Research keyword opportunities', 'Volume, CPC, competition, difficulty, and related queries', 'semrush.keywords'),
    defineOutcome('Analyze domain performance', 'Authority, traffic, keywords, backlinks, and top markets', 'semrush.overview'),
  ],
  seo: [
    defineOutcome('Research keywords and intent', 'Ideas, suggestions, volume, difficulty, CPC, and search intent', 'seo.keyword_ideas', 'seo.keyword_suggestions', 'seo.related_keywords', 'seo.keyword_overview', 'seo.keyword_difficulty', 'seo.search_volume', 'seo.search_intent'),
    defineOutcome('Analyze domains and competitors', 'Rankings, traffic, overlap, competitors, and shared keywords', 'seo.domain_rank_overview', 'seo.ranked_keywords', 'seo.competitors_domain', 'seo.domain_intersection'),
    defineOutcome('Research local search results', 'Google local pack positions, ratings, reviews, phones, and websites', 'seo.local_pack'),
  ],
  spotify: [
    defineOutcome('Research artists and music', 'Artists, albums, tracks, discographies, and release details', 'spotify.artist', 'spotify.album', 'spotify.track'),
    defineOutcome('Measure listening performance', 'Play counts, popularity, and track statistics', 'spotify.play_count'),
    defineOutcome('Discover audio and podcasts', 'Search, shows, episodes, topics, and playlists', 'spotify.search', 'spotify.podcast', 'spotify.podcast_episodes'),
  ],
  web: [
    defineOutcome('Extract content from web pages', 'Clean Markdown, HTML, metadata, and browser screenshots', 'web.scrape', 'web.screenshot'),
    defineOutcome('Map and crawl websites', 'Site URLs, page titles, descriptions, and multi-page content', 'web.map', 'web.crawl'),
  ],
  yahoo_finance: [
    defineOutcome('Track stocks and ETFs', 'Prices, market cap, volume, and key quote statistics', 'yahoo_finance.quote'),
  ],
  youtube: [
    defineOutcome('Understand channels and audiences', 'Channel statistics, videos, Shorts, live streams, and playlists', 'youtube.channel', 'youtube.channel_videos', 'youtube.channel_shorts', 'youtube.channel_lives', 'youtube.channel_playlists'),
    defineOutcome('Analyze videos and conversations', 'Video metadata, transcripts, sponsors, comments, and replies', 'youtube.video', 'youtube.video_transcript', 'youtube.video_sponsors', 'youtube.video_comments', 'youtube.comment_replies', 'youtube.playlist', 'youtube.community_post', 'youtube.channel_community_posts'),
    defineOutcome('Discover videos and trends', 'Keyword and hashtag search plus trending Shorts', 'youtube.search', 'youtube.search_hashtag', 'youtube.trending_shorts'),
  ],
};
